import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "./Button"; // Custom Button component
import { SafeHtmlParser } from "./SafeHtmlParser";

const Cta1 = ({ heading, body, colour, button, image }) => {
	return (
		<section
			className="py-5 py-lg-7"
			style={{
				position: "relative",

				textAlign: "center",
			}}
		>
			<Container>
				<Row className="justify-content-center">
					<Col md={10} lg={8}>
						<div style={{ color: colour }}>
							<SafeHtmlParser htmlContent={heading} />
						</div>
						<div className="mt-3 mb-4">
							<SafeHtmlParser htmlContent={body} />
						</div>
						{button && (
							<Button
								width="w-100 w-md-auto"
								colour={colour} // Default navy blue for the button
								text={button.title}
								link={button.url}
								isOutline={false}
							/>
						)}
					</Col>
				</Row>
			</Container>
			{image && <img style={graphicStyles} src={image}></img>}
		</section>
	);
};

// Inline styles

const graphicStyles = {
	position: "absolute",
	bottom: "-15vw",
	right: "-15vw",
	zIndex: -1,

	width: "35vw",
};

export default Cta1;
